module.exports = __webpack_public_path__ + "img/logo_cooservunal.580c4ea.png";